import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PortalProvider } from "@/context/PortalContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import LogisticsPage from "@/pages/LogisticsPage";
import RentalsPage from "@/pages/RentalsPage";
import WaterPage from "@/pages/WaterPage";
import BinPage from "@/pages/BinPage";
import DiagnosticsPage from "@/pages/DiagnosticsPage";
import TruckingPage from "@/pages/TruckingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AuthCallback from "@/pages/AuthCallback";
import DashboardPage from "@/pages/DashboardPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PortalSelectPage from "@/pages/PortalSelectPage";
import RentalsPortalPage from "@/pages/RentalsPortalPage";
import TruckingPortalPage from "@/pages/TruckingPortalPage";
import LeasingPage from "@/pages/LeasingPage";
import InvoicePage from "@/pages/InvoicePage";
import InstallPrompt from "@/components/InstallPrompt";
import "@/App.css";

function RouteSwitch() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/logistics" element={<LogisticsPage />} />
      <Route path="/logistics/water" element={<WaterPage />} />
      <Route path="/logistics/bin" element={<BinPage />} />
      <Route path="/logistics/diagnostics" element={<DiagnosticsPage />} />
      <Route path="/logistics/trucking" element={<TruckingPage />} />
      <Route path="/rentals" element={<RentalsPage />} />
      <Route path="/leasing" element={<LeasingPage />} />
      <Route path="/portal-select" element={<PortalSelectPage />} />
      <Route path="/portal/rentals" element={<RentalsPortalPage />} />
      <Route path="/portal/trucking" element={<TruckingPortalPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/invoice/:id" element={<InvoicePage />} />
      <Route path="/i/:token" element={<InvoicePage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PortalProvider>
            <RouteSwitch />
            <InstallPrompt />
            <Toaster position="top-right" richColors />
          </PortalProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
